'use strict';

var App = require('app');
var Strings = require('utils/strings');

var ValueSpecs = Backbone.Model.extend({});

var ValueSpecsCollection = Backbone.Collection.extend({
    model: ValueSpecs,
    comparator: 'name',

    initialize: function (options) {
        this.type = options.type || 'MBR';
        this.group = options.group || '55xx56xx';
        this.filterAttr = options.filterAttr;
    },

    url: function () {
        var filter = {
            vt: this.type,
            vg: this.group,
        };
        _.extend(filter, this.filterAttr);

        return '/api/v1/valuespecs' + Strings.joinURLparameter(filter);
    },
});

var API = {
    getValueSpecs: function (type, group, filterAttr) {
        var valueSpecs = new ValueSpecsCollection({
            type: type,
            group: encodeURI(group),
            filterAttr: filterAttr,
        });

        var defer = $.Deferred();
        valueSpecs.fetch({
            success: function (data, result) {
                if (result === null) {
                    // handle empty response
                    data.models = undefined;
                }
                defer.resolve(data);
            },
            error: function (data) {
                defer.resolve(undefined);
            },
        });

        return defer.promise();
    },
};

App.reqres.setHandler('device:valuespecs', function (type, group, filterAttr) {
    return API.getValueSpecs(type, group, filterAttr);
});

module.exports = ValueSpecsCollection;
